import { mapPickingStatusToDeliveryOrderStatus } from '../../../../DeliveryOrdersPicking/constants/status'

export const STATUS_CAN_ASSIGN_PICKER = [
  'DELIVERY_ORDER_STATUS_PENDING',
  'DELIVERY_ORDER_STATUS_PROCESSING',
]

export const STATUS_CAN_EDIT_PACKLIST = [
  'DELIVERY_ORDER_STATUS_PROCESSING',
  'DELIVERY_ORDER_STATUS_PICKING',
  'DELIVERY_ORDER_STATUS_PACKING',
  'DELIVERY_ORDER_STATUS_PACKED',
]

export const STATUS_CAN_PRINT_ORDER = [
  'DELIVERY_ORDER_STATUS_PENDING',
  'DELIVERY_ORDER_STATUS_PICKING',
  'DELIVERY_ORDER_STATUS_PICKED',
  'DELIVERY_ORDER_STATUS_PACKING',
  'DELIVERY_ORDER_STATUS_COMPLETED',
  'DELIVERY_ORDER_STATUS_DISPATCHED',
  'DELIVERY_ORDER_STATUS_PACKED',
  'DELIVERY_ORDER_STATUS_PROCESSING',
]

export const hasEditablePacklist = (packlistData = []) => {
  if (!packlistData || packlistData.length === 0) {
    return true
  }

  return packlistData.some(
    (packlist) =>
      packlist.status === 'PACKLIST_STATUS_PACKED' ||
      packlist.status === 'PACKLIST_STATUS_RECEIVED'
  )
}

export const hasPrintablePackageCodes = (packlistData = []) =>
  Boolean(
    packlistData &&
      packlistData.length > 0 &&
      packlistData.flatMap((x) => x.packages || []).length > 0
  )

export const hasPickablePacklist = (packlistData = []) =>
  Boolean(
    packlistData &&
      packlistData.length > 0 &&
      packlistData.some((x) => x.status === 'PACKLIST_STATUS_PENDING')
  )

export const getMappedDeliveryOrderStatus = (pickingStatus) =>
  mapPickingStatusToDeliveryOrderStatus(pickingStatus)

// A PICKING order whose packlists are all back to PENDING has no active picker
// (e.g. after an unassign), so it can be reassigned. Partly picked orders can't.
export const hasOnlyPendingPacklists = (packlistData = []) => {
  const activePacklists = (packlistData || []).filter(
    (x) => x.status !== 'PACKLIST_STATUS_CANCELLED'
  )

  return (
    activePacklists.length > 0 &&
    activePacklists.every((x) => x.status === 'PACKLIST_STATUS_PENDING')
  )
}

export const canAssignPicker = ({ order, packlistData = [] } = {}) => {
  if (!order) {
    return false
  }
  const mappedStatus = getMappedDeliveryOrderStatus(order.status)
  if (STATUS_CAN_ASSIGN_PICKER.includes(mappedStatus)) {
    return true
  }

  return (
    mappedStatus === 'DELIVERY_ORDER_STATUS_PICKING' &&
    hasOnlyPendingPacklists(packlistData)
  )
}

export const canEditPacked = ({ order, packlistData } = {}) => {
  if (!order) {
    return false
  }
  const mappedStatus = getMappedDeliveryOrderStatus(order.status)
  return (
    STATUS_CAN_EDIT_PACKLIST.includes(mappedStatus) &&
    hasEditablePacklist(packlistData)
  )
}

export const canPrintLabels = ({ order, packlistData } = {}) => {
  if (!order) {
    return false
  }
  const mappedStatus = getMappedDeliveryOrderStatus(order.status)
  return (
    STATUS_CAN_PRINT_ORDER.includes(mappedStatus) &&
    hasPrintablePackageCodes(packlistData)
  )
}

export const buildAssignPickerData = (order) => ({
  store: { id: order?.storeId },
})

// DSP slots are time-only strings, while the print form expects a full
// timestamp it can hand to moment / Date.
const toSlotTimestamp = (preferredDate, slotTime) => {
  if (!slotTime) {
    return undefined
  }
  if (!preferredDate || String(slotTime).includes('T')) {
    return slotTime
  }
  return `${String(preferredDate).split('T')[0]}T${slotTime}`
}

export const buildPrintOrderData = (order) => ({
  slotStartTime: toSlotTimestamp(order?.preferredDate, order?.slotStartTime),
  slotEndTime: toSlotTimestamp(order?.preferredDate, order?.slotEndTime),
  deliveryAddress: {
    addresseeName: order?.orderAddress?.addresseeName || '-',
  },
})

export const getPackageCount = (packlistData = []) =>
  (packlistData || []).flatMap((x) => x.packages || []).length
